import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaInstagram } from 'react-icons/fa';
import colorPalette from './styles/colorPalette';
import LoadingBar from './LoadingBar';  // Import the new LoadingBar component
import './styles.css';

import OpenAI from 'openai';

const { primary, secondary, tertiary, quaternary, quinary } = colorPalette;

const MAX_GAME_COUNT = process.env.MAX_GAME_COUNT || 1;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100vh;
  background-color: ${primary};
  color: ${quaternary};
`;

const Title = styled.h1`
  font-size: 48px;
  margin-top: 30px;
  margin-bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
`;

const Button = styled.button`
  padding: 16px;
  font-size: 24px;
  font-weight: bold;
  color: ${primary};
  background-color: ${quaternary};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: ${quinary};
  }
  &:active {
    transform: translateY(5px);
  }
`;

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  background-color: ${secondary};
`;

const SocialMediaIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;
  font-size: 24px;
  color: ${quaternary};
  &:hover {
    color: ${quinary};
  };
  display: inline-block;
  flex-direction: column; 
`;

function App() {
  const [screenClass, setScreenClass] = useState('screen');
  const [gameFileLoc, setGameFileLoc] = useState(`<html><h1>Welcome to BoxGPT</h1></html`);
  const [isLoading, setIsLoading] = useState(false);


  async function generateGameCode() {
    try {
      setIsLoading(true);
      const openai = new OpenAI({ apiKey: process.env.REACT_APP_OPENAI_API_KEY, dangerouslyAllowBrowser: true });
      console.log("Running gpt now, please wait.");
      const completion = await openai.chat.completions.create({
        model: "gpt-4o",
        messages: [
          { "role": "system", "content": "You are a game developer professional with excellent front-end code writing capabilities. You are creative." },
          {
            "role": "user", "content": "Write code for an awesome game using html,css and plain javascript. Combine it into a single file. Use style tag to make the game look awesome. It must fit within React's screen small-screen (useState('screen')) - but do not use React. Some basic examples of games are: tic tac toe, rock paper scissors, guess the number, etc. Do not limit your creativity only to these listed games - think beyond."
          }
        ],
        temperature: 0.7
      });

      let answer = completion.choices[0].message.content;
      answer = answer.split(`\`\`\``)[1];
      answer = answer.replace(/html\n/g, "");

      const blob = new Blob([answer], { type: "text/html" });
      const blobUrl = URL.createObjectURL(blob);

      await new Promise(resolve => setTimeout(resolve, 2000));


      // Update gameFileLoc with the generated blob URL
      setGameFileLoc(blobUrl);
      
      // Stop loading
      setIsLoading(false);

      console.log("Generated game HTML:", answer);
      return true;
    }
    catch (err) {
      console.log(err?.response?.data?.error);
      console.log(err?.response?.status);
      setIsLoading(false);
      throw err;
    }
  }

  const handleClick = async () => {
    await generateGameCode();
  };

  useEffect(() => {
    window._alert = window.alert;
    window.alert = function () {
    };

    const setScreenSize = () => {
      if (window.matchMedia('(max-width: 600px)').matches) {
        setScreenClass('screen small-screen');
      } else {
        setScreenClass('screen');
      }
    };

    generateGameCode();
    setScreenSize();
    window.addEventListener('resize', setScreenSize);

    return () => window.removeEventListener('resize', setScreenSize);
  }, []);

  return (
    <Container>

      <Title>BoxGPT</Title>

      <div className='game-container'>
        {!isLoading && (
          <iframe
            className={screenClass}
            src={gameFileLoc}
            width="100%"
            height="100%"
            style={{ overflow: "hidden" }}
            title="gameframe"
          >
          </iframe>
        )}
      </div>
      <ButtonContainer>
        {isLoading ? (
          <LoadingBar />
        ) : (
          <Button 
            className="myButton" 
            onClick={handleClick}
          >
            Generate a new game for me!
          </Button>
        )}
      </ButtonContainer>

      <Footer>
        <SocialMediaIcon href="https://www.instagram.com/addy.0_0/" rel="noreferrer noopener" target="_blank">
          <FaInstagram />
        </SocialMediaIcon>
        <p style={{ display: 'block' }}>&copy; 2024 BoxGPT. All rights reserved.</p>
        <a className="contact-dev-button" href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" rel="noreferrer noopener" target="_blank">Contact Developer</a>
      </Footer>
    </Container>
  );
}

export default App;
